window.addEventListener('DOMContentLoaded', () => {

   const body = document.querySelector('body');
   const nav = document.querySelectorAll('.js-nav-click');
   const screen = document.querySelector('.js-screen');
   const docToggle = document.querySelectorAll('.js-doc-toggle');

   let touchStart = false;

   nav.forEach((el) => {
      el.addEventListener('click', (event) => {
         event.preventDefault();

         if (!touchStart) {
            if (screen.style.display === 'block') {
               body.style.overflow = '';
               screen.style.display = '';
            } else {
               screen.style.display = 'block';
               body.style.overflow = 'hidden';
            }
         }
      });

      el.addEventListener('touchend', (event) => {
         touchStart = true;

         if (screen.style.display === 'block') {
            body.style.overflow = '';
            screen.style.display = '';
         } else {
            screen.style.display = 'block';
            body.style.overflow = 'hidden';
         }
      });
   });

   window.addEventListener('keyup', (event) => {
      const body = document.querySelector('body');
      const nav = document.querySelectorAll('.js-nav-click');
      const screen = document.querySelector('.js-screen');

      if (event.code.toLowerCase() == 'escape' && screen.style.display == 'block') {
         if (screen.style.display === 'block') {
            body.style.overflow = '';
            screen.style.display = '';
         }
      }
   });


   docToggle.forEach((el) => {
      el.addEventListener('click', (event) => {
         event.preventDefault();
         const clickedIcon = el.querySelector('.js-doc-toggle-icon');
         const hiddenBox = el.parentNode.nextElementSibling;

         if (hiddenBox.style.display === 'none') {
            hiddenBox.style.display = 'block';
            clickedIcon.classList.remove('fa-chevron-right');
            clickedIcon.classList.add('fa-chevron-down');
         } else {
            clickedIcon.classList.remove('fa-chevron-down');
            clickedIcon.classList.add('fa-chevron-right');
            hiddenBox.style.display = 'none';
         }
      });
   });
});



// WEBPACK FOOTER //
// ./src/js/app.js